import { FieldTemplate } from './FieldTemplate';
import { FormTemplate } from './FormTemplate';
import { UserSlim } from './UserSlim';

export enum FormStatus {
  New = 'new',
  Filling = 'filling',
  Filled = 'filled',
  Finalized = 'finalized',
  Closed = 'closed',
  Deleted = 'deleted',
}

export enum FieldImportStatus {
  IMPORT_ERRORED = 'importErrored',
  IMPORTED = 'imported',
  IMPORTED_OVERWRITTEN = 'importedOverwritten',
  IMPORT_SKIPPED = 'importSkipped',
}

export interface FieldImportMeta {
  importStatus: FieldImportStatus;
  originalValue: string;
}

export type Field = {
  fieldType?: string;
  valueType?: string;
  fieldTemplateId: string;
  value: string | number | string[] | boolean;
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
  repeatIndex?: number;
  layoutRepeatIndex?: number[];
  importMeta?: FieldImportMeta;
};

export type Form = {
  id: string;
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
  status: FormStatus;
  fields: Field[];
  externalFields?: Field[];
  externalFieldTemplates?: FieldTemplate[];
  formTemplateId: string;
  formTemplateTypeId?: string;
  template?: FormTemplate;
  fieldTemplates?: FieldTemplate[];
  slimUser?: UserSlim;
};
